// extracted by mini-css-extract-plugin
export var brand = "_a7-9";
export var compact = "_a7-6";
export var extraSmall = "_a7-7";
export var icon = "_a7-0";
export var large = "_a7-4";
export var light = "_a7-1";
export var medium = "_a7-5";
export var outline = "_a7-b";
export var primaryDark = "_a7-a";
export var primaryLight = "_a7-8";
export var primaryModern = "_a7-c";
export var success = "_a7-2";
export var successSolid = "_a7-3";